import jwt from 'jwt-decode';
// @ts-ignore
import Drawer from 'components/Nav/Drawer';
import Footer from 'components/Nav/Footer';
import { ContentContainer } from './index';
import Tableau from 'components/Tableau';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const TuDashboard = ({ userName }: { userName: string }) => {
  return (
    <Box mb={2} style={{ marginTop: '-15px' }}>
      <Typography
        sx={{ fontSize: { xs: '1.8rem', sm: '3rem' } }}
        variant="h3"
        fontWeight="700"
      >
        &lt; {userName} <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '2rem', sm: '3.3rem' } }} variant="h3" fontWeight="700">dashboard</Typography>&gt;
      </Typography>
    </Box>
  );
};

const DashboardPerformance = () => {
  const { clientCompany: userName } = jwt(localStorage.getItem('token') as string) as any;
  const tableauToken = localStorage.getItem('tableauToken') as string;

  return (
    <ContentContainer>
      <Drawer>
        <TuDashboard userName={userName} />
        <Tableau src='Performance' token={tableauToken} />
      </Drawer>
      <Footer />
    </ContentContainer>
  );
};

export default DashboardPerformance;
